export default function Api(props: any) {

  return (
    <iframe
        id="inlineFrameExample"
        title="Inline Frame Example"
        width="100%"
        height="100%"
        src="/api/docs"
        style= {{border: 0}}
      />
  )
}